import { Controller } from "react-hook-form";
import CustomButton from "../ui/CustomButton/CustomButton";
import { CustomText } from "../ui/CustomText/CustomText";
import { CustomPinInput } from "../ui/CustomPin/CustomPin";
import { pinValidator } from "../../lib/validations/authValidations";

export function PinAuthorizeStep({
  control,
  handleSubmit,
  pinValue,
  onSubmit,
  isAuthorizing = false,
  submitLabel,
}) {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-1">
        <h3 className="text-base font-semibold text-gray-900">
          Enter Your PIN
        </h3>
        <p className="text-sm text-gray-500">
          Enter your 6-digit PIN to authorize this transaction
        </p>
      </div>

      <Controller
        name="pin"
        control={control}
        rules={{ validate: (v) => pinValidator(v) ?? true }}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-2">
            <CustomPinInput
              length={6}
              mask
              justify="center"
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={isAuthorizing}
            />
            {fieldState.error && (
              <CustomText c="error" size="sm" align="center">
                {fieldState.error.message}
              </CustomText>
            )}
          </div>
        )}
      />

      <div className="flex justify-center">
        <CustomButton
          color="primary"
          radius="md"
          loading={isAuthorizing}
          disabled={Boolean(pinValidator(pinValue)) || isAuthorizing}
          onClick={handleSubmit(onSubmit)}
        >
          {submitLabel}
        </CustomButton>
      </div>
    </div>
  );
}
